export default {"src":"/_next/static/media/mouse_bold.6b13e642.svg","height":24,"width":24};